import { HomeString } from "../../utils/string";
import SearchIcon from "../../assets/Images/searchIcon.svg";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { ApplicationId } from "../../api/url";
import { getAllMachinesModelList, getMasterModelsByMake } from "../../services/machineService";

const FilterComponent = ({ List, isLoader, machinesMakeList, makeLoading }) => {
  const [keywords, setKeyWord] = useState();
  const [selectCategory, setSelectCategory] = useState(null);
  const [selectMake, setSelectMake] = useState(null);
  const [selectModel, setSelectModel] = useState(null);
  //
  const [machinesModelList, setMachinesModelList] = useState([]);
  const [modelLoading, setModelLoading] = useState(false);

  const [selectCategoryObject, setSelectCategoryObject] = useState(null);
  const [selectMakeObject, setSelectMakeObject] = useState(null);
  const navigate = useNavigate();
  const PavingMarketCategories = List.find((item) => item.AssetTypeId === 2)?.CategoryDetails?.sort((a, b) =>
    a?.CategoryName.localeCompare(b?.CategoryName)
  );

  useEffect(() => {
    if (selectMake) {
      GetMachinesModelList();
    }
  }, [selectMake]);

  const GetMachinesModelList = () => {
    setModelLoading(true);

    const selectedMakeObj = machinesMakeList?.find((item) => item.MakeId.toString() === selectMake);
    const makeName = selectedMakeObj?.MakeName;

    if (!makeName) {
      setModelLoading(false);
      return;
    }

    const payload = {
      applicationId: ApplicationId,
      makeName: [makeName],
      isFromAdvertisement: true
    };

    console.log("payloadww", payload);
    getMasterModelsByMake(payload)
      .then((res) => {
        setModelLoading(false);
        setMachinesModelList(res?.data || []);
      })
      .catch((err) => {
        setModelLoading(false);
        console.log(err);
        setMachinesModelList([]);
      });
  };

  return (
    <div className="bg-[#F2F2F2]">
      <div className="custom-container">
        <div className="max-w-[650px] mx-auto py-[72px]">
          <div className="text-[22px] md:text-[32px] text-black font-light leading-[32px]">
            {HomeString.Home_Source}
          </div>
          <div className="text-[22px] md:text-[32px] text-black font-bold leading-[32px]">{HomeString.Used_Paving}</div>

          <div className="my-[13px] flex max-[660px]:flex-col">
            <input
              className="border border-[#FEBA06] text-black placeholder-[#b3b3b3] px-[12px] py-[10px] font-normal text-[16px] w-[84%] max-[674px]:w-[82%] max-[660px]:w-full max-[660px]:mb-2 outline-none"
              placeholder="Enter Keywords..."
              onChange={(e) => setKeyWord(e.target.value)}
            />
            <button
              className="border border-[#FEBA06] bg-[#FEBA06] px-[19px] py-[12px] font-bold text-[16px] w-[16%] max-[674px]:w-auto max-[660px]:w-full  text-[#161412]"
              onClick={() =>
                navigate(`/search`, {
                  state: {
                    keywords: keywords,
                    selectCategory: selectCategoryObject ? JSON.stringify([selectCategoryObject]) : "",
                    selectMake: selectMakeObject ? JSON.stringify([selectMakeObject]) : "",
                  },
                })
              }
            >
              {HomeString.SEARCH}
            </button>
          </div>

          <div className="my-[13px]">
            <div className="flex flex-wrap gap-[15px] max-[640px]:flex-col">
              <div className="custom-select">
                <select
                  className="w-full md:w-auto flex-grow font-normal border border-[#FEBA06] px-[12px] py-[10px]"
                  value={selectCategory}
                  onChange={(e) => {
                    const selectedCategoryId = e.target.value;
                    const selectedCategory = PavingMarketCategories?.find(
                      (item) => item.CategoryId.toString() === selectedCategoryId
                    );
                    setSelectCategoryObject(selectedCategory);
                    setSelectCategory(selectedCategoryId); // Save the full object in state
                  }}
                >
                  {/* Placeholder Option */}
                  <option value="" disabled selected className="text-gray-500">
                    Category
                  </option>

                  {/* Dynamic Options */}
                  {PavingMarketCategories?.map((item) => (
                    <option key={item?.CategoryId} value={item?.CategoryId} targetValue={item} className="text-black">
                      {item?.CategoryName}
                    </option>
                  ))}
                </select>
              </div>

              <div className="custom-select">
                <select
                  className="w-full md:w-auto flex-grow font-normal border border-[#FEBA06] px-[12px] py-[10px]"
                  value={selectMake} // Controlled by state
                  onChange={(e) => {
                    const selectedMakeId = e.target.value;
                    const selectedMake = machinesMakeList?.find((item) => item.MakeId.toString() === selectedMakeId);
                    setSelectMakeObject(selectedMake);
                    setSelectMake(selectedMakeId);
                  }}
                >
                  {/* Placeholder Option */}
                  <option value="0" disabled selected className="text-gray-500">
                    Make
                  </option>

                  {/* Dynamic Options */}
                  {machinesMakeList?.map((item) => (
                    <option key={item?.MakeId} value={item?.MakeId} targetValue={item} className="text-black">
                      {item?.MakeName}
                    </option>
                  ))}
                </select>
              </div>

              <div className="custom-select">
                <select
                  className="w-full md:w-auto flex-grow font-normal border border-[#FEBA06] px-[12px] py-[10px]"
                  value={selectModel} // Controlled by state
                  onChange={(e) => {
                    setSelectModel(e.target.value);
                  }}
                >
                  <option selected value="0">
                    Model
                  </option>
                  {machinesModelList?.map((item) => (
                    <option key={item?.ModelId} value={item?.ModelName} targetValue={item} className="text-black">
                      {item?.ModelName}
                    </option>
                  ))}
                </select>
              </div>

              <div
                className="flex items-center justify-center p-[11px] bg-[#FEBA06] cursor-pointer w-full md:w-auto"
                onClick={() =>
                  navigate(`/search`, {
                    state: {
                      keywords: keywords,
                      selectCategory: selectCategoryObject ? JSON.stringify([selectCategoryObject]) : "",
                      selectMake: selectMakeObject ? JSON.stringify([selectMakeObject]) : "",
                      selectModel: selectModel ? JSON.stringify([selectModel]) : "",
                    },
                  })
                }
              >
                <img src={SearchIcon} alt="Search" width={19} className="w-[19px]" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default FilterComponent;
